import { ConfigurationState, FeatureState, IContentAPIConfigurationState } from "./ConfigurationState";
import { ItemBase, IContentAPIItemBase } from "./ItemBase";

export class ItemVariantProposalFactory {
    static create(itemVariantProposal: IItemVariantProposal | V2.IItemVariantProposal): IContentAPIItemVariantProposal {
        return new ItemVariantProposal(itemVariantProposal).serialize();
    }
}

export class ItemVariantProposal extends ItemBase {
    protected _proposedConfigurationState?: ConfigurationState;
    protected _foundBySearch?: boolean;

    constructor(variantProposal: IItemVariantProposal | V2.IItemVariantProposal) {
        super(variantProposal);

        let configurationState: IConfigurationState | undefined = (variantProposal as IItemVariantProposal).proposedConfigurationState ?? (variantProposal as V2.IItemVariantProposal).configurationState;
        if (configurationState?.length) {
            this._proposedConfigurationState = [];
            configurationState.forEach((featureState: IFeatureState) => {
                this._proposedConfigurationState?.push(new FeatureState(featureState));
            });
        }

        this._foundBySearch = (variantProposal as V2.IItemVariantProposal).foundBySearch;
    }

    get proposedConfigurationState(): ConfigurationState | undefined {
        return this._proposedConfigurationState;
    }

    get configurationState(): ConfigurationState | undefined {
        return this._proposedConfigurationState;
    }

    get foundBySearch(): boolean | undefined {
        return this._foundBySearch;
    }

    serialize(): IContentAPIItemVariantProposal {
        const itemVariantProposal: IContentAPIItemVariantProposal = {
            ...super.serialize()
        };

        if (this.configurationState !== undefined) {
            itemVariantProposal.proposedConfigurationState = this.configurationState.map((featureState: FeatureState) => featureState.serialize());
            itemVariantProposal.configurationState = itemVariantProposal.proposedConfigurationState;
        }

        if (this._foundBySearch !== undefined) {
            itemVariantProposal.foundBySearch = this._foundBySearch;
        }

        return itemVariantProposal;
    }
}

export interface IContentAPIItemVariantProposal extends IContentAPIItemBase {
    /** @deprecated use configurationState instead */
    proposedConfigurationState?: IContentAPIConfigurationState;

    /** The proposed configuration state for this variant. */
    configurationState?: IContentAPIConfigurationState;

    /** Whether this proposal was found via search (true) or provided explicitly (false/undefined). */
    foundBySearch?: boolean;
}